<app-window-title [closable]="true"
                  [titleHTML]="getHTMLTitle()"></app-window-title>

<!-- Add the action buttons at the top -->
<div class="top-action-buttons"
     fxLayout="row"
     fxLayoutAlign="end center"
     fxLayoutGap="16px">
  <button color="primary"
          style="background-color: rgb(78, 108, 163); color: rgb(255, 255, 255);"
          mat-button
          (click)="showDestinationPanel = true">
    <mat-icon class="destination-icon">
      library_books
    </mat-icon>
    View shared Clio files
  </button>
  <button style="background-color: rgb(26, 81, 182); color: white;"
          mat-flat-button
          (click)="navigateBackToClio()">
    <mat-icon>
      assignment_turned_in
    </mat-icon>
    Open the Matter in Clio
  </button>
  <button color="warn"
          style="color:white"
          mat-flat-button
          (click)="navigateToMatter()">
    <mat-icon>
      account_circle
    </mat-icon>
    Open the Client/Matter in NuageDx
  </button>
</div>

<!-- file-transfer.component.html -->
<div class="file-transfer-container">
  <!-- File panels -->
  <div class="panels-container"
       fxLayout="row"
       fxLayoutGap="12px">
    <!-- Source files panel with breadcrumb navigation -->
    <app-source-files-panel [currentFolderContents]="currentFolderContents"
                            [displayedItems]="getDisplayedItems()"
                            [fileCheckingComplete]="fileCheckingComplete"
                            [filteredFolderContents]="filteredFolderContents"
                            [label]="label"
                            [loadingFolderId]="loadingFolderId"
                            [searchQuery]="searchQuery"
                            [showSearchInput]="showSearchInput"
                            [sourceObjectName]="sourceObjectName"
                            [subFolders]="subfolders"
                            (clearSearchEvent)="clearSearch()"
                            (openClioFilePreviewEvent)="openClioFilePreview($event)"
                            (searchClioFilesEvent)="searchClioFiles($event)"
                            (toggleFileSelectionEvent)="toggleFileSelectionDirect($event.item, $event.checked)"
                            (toggleFolderEvent)="toggleFolder($event)"
                            (toggleFolderSelectionEvent)="toggleFolderSelectionDirect($event.folder, $event.checked)">
    </app-source-files-panel>

    <!-- Selected files panel with split view and transfer log -->
    <div class="selected-panel-container"
         fxLayout="column">
      <!-- Use our new selected files panel component -->
      <app-selected-files-panel [selectedFiles]="selectedFiles"
                                [title]="'Files selected to be shared'"
                                (fileCheckboxChange)="rightPanelCheckboxChangeDirect($event)"
                                (shareSelectedFiles)="transferSelectedFiles()">
      </app-selected-files-panel>

      <!-- Transfer log panel (bottom) -->
      <mat-card *ngIf="showTransferLog"
                class="file-panel selected-panel transfer-log-panel"
                fxFlex>
        <mat-card-header>
          <mat-card-title>
            <span>
              Recently Shared Files
            </span>
            <button class="clear-log-button danger nuage-button small"
                    (click)="clearTransferLog()">
              <mat-icon>
                delete_sweep
              </mat-icon>
              Clear Log
            </button>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="transfer-log-container"
               style="overflow-y: auto;">
            <div *ngIf="transferLogItems.length === 0"
                 class="no-logs-message">
              <mat-icon>
                info
              </mat-icon>
              <p>
                No recent transfers to display.
              </p>
            </div>
            <div *ngIf="transferLogItems.length > 0"
                 class="transfer-log-list">
              <div *ngFor="let logItem of transferLogItems"
                   class="log-item"
                   [ngClass]="{'success': logItem.status === 'success', 'error': logItem.status === 'error'}">
                <div class="log-item-header">
                  <mat-icon class="log-status-icon">
                    {{logItem.status === 'success' ? 'check_circle' : 'error'}}
                  </mat-icon>
                  <span class="log-item-name">
                    {{logItem.name}}
                  </span>
                  <span class="log-item-time">
                    {{logItem.timestamp | date:'short'}}
                  </span>
                </div>
                <div *ngIf="logItem.details"
                     class="log-item-details">
                  {{logItem.details}}
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Destination panel overlay -->
  <app-nuagedx-files-panel [nuageDxFiles]="nuageDxFiles"
                           [visible]="showDestinationPanel"
                           (backToClio)="backToClio($event)"
                           (closePanel)="showDestinationPanel = false"
                           (previewFile)="openNuageDxFilePreview($event)">
  </app-nuagedx-files-panel>

  <!-- Duplicates warning panel - moved above the action buttons -->
  <div *ngIf="showDuplicatesPanel"
       class="duplicates-overlay"
       fxLayout="column"
       fxLayoutAlign="center center">
    <div class="duplicates-panel">
      <!-- Updated close button -->
      <button class="close-duplicates-button danger nuage-button small"
              (click)="showDuplicatesPanel = false">
        <mat-icon>
          close
        </mat-icon>
      </button>
      <mat-card *ngIf="hasExactDuplicates && showDuplicatesPanel"
                class="duplicates-panel">
        <mat-card-content>
          <p class="duplicate-warning">
            Some of the files you selected are duplicates.
          </p>
          <div class="duplicated-files-section">
            <div class="duplicated-title">
              <mat-icon class="warning-icon">
                warning
              </mat-icon>
              <span>
                Duplicated files:
              </span>
            </div>
            <div class="duplicated-files-list">
              <div *ngFor="let file of duplicatedFiles; let i = index"
                   class="duplicated-file-item">
                <mat-checkbox [checked]="true"
                              [(ngModel)]="file.selected"></mat-checkbox>
                <mat-icon class="file-icon">
                  insert_drive_file
                </mat-icon>
                <span class="file-name">
                  <!-- Show original name for most duplicates -->
                  <ng-container *ngIf="!(selectedResolutionOption === 'rename' && i === 0)">
                    {{file.name}}
                  </ng-container>
                  <!-- Show preview of renamed file for the first duplicate when Rename is selected -->
                  <ng-container *ngIf="selectedResolutionOption === 'rename' && i === 0">
                    <span class="rename-preview">
                      {{getRenamingPreview(file.name)}}
                    </span>
                  </ng-container>
                </span>
                <!-- Added file location display with minimal extra space -->
                <span *ngIf="file.parentFolder"
                      class="file-location">
                  (
                  <mat-icon class="location-icon"
                            style="font-size:14px; vertical-align:middle;">
                    folder_open
                  </mat-icon>
                  {{file.parentFolder}})
                </span>
                <span *ngIf="file.size"
                      class="file-size">
                  {{file.size}}
                </span>
                <span *ngIf="file.date"
                      class="file-date">
                  {{file.date}}
                </span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- File loading indicator - shows when files are being checked -->
  <div *ngIf="!fileCheckingComplete"
       class="file-checking-indicator">
    <mat-spinner class="check-spinner"
                 diameter="24"></mat-spinner>
    <span class="check-message">
      {{fileCheckingMessage}}
    </span>
  </div>
</div>

<!-- File Preview Overlay -->
<div *ngIf="showFilePreview"
     class="file-preview-overlay">
  <div class="file-preview-container">
    <div class="file-preview-header">
      <div class="preview-title">
        <mat-icon>
          {{previewFileItem?.type === 'image' ? 'image' : 'description'}}
        </mat-icon>
        <h3>
          {{previewFileItem?.name}}
        </h3>
      </div>
      <div class="preview-actions">
        <button mat-icon-button
                (click)="downloadPreview()">
          <mat-icon>
            download
          </mat-icon>
        </button>
        <button mat-icon-button
                (click)="closeFilePreview()">
          <mat-icon>
            close
          </mat-icon>
        </button>
      </div>
    </div>
    <div class="file-preview-content">
      <ng-container *ngIf="previewFileItem?.type === 'image'">
        <div class="image-preview-placeholder">
          <mat-icon class="image-icon">
            image
          </mat-icon>
          <p>
            {{previewFileItem?.content}}
          </p>
        </div>
      </ng-container>
      <ng-container *ngIf="previewFileItem?.type === 'file'">
        <div class="file-content">
          <p>
            {{previewFileItem?.content}}
          </p>
        </div>
      </ng-container>
    </div>
    <div class="file-preview-footer">
      <div class="file-info">
        <span class="file-size">
          Size: {{previewFileItem?.size}}
        </span>
        <span class="file-date">
          Date: {{previewFileItem?.date}}
        </span>
      </div>
      <button class="nuage-button secondary"
              mat-button
              (click)="closeFilePreview()">
        Close
      </button>
    </div>
  </div>
</div>
